<template>
  <!-- Streaming Details -->
  <v-card flat>
    <!-- External Source -->
    <template v-if="isExternalSrc">
      <v-card-text class="pb-0 px-0">
        <v-layout row wrap>
          <v-flex xs12 md12>
            <v-btn
              flat
              class="primary--text"
              v-if="movie && movie.encoding_url"
              @click="setMediaEncUrlAsExtSrc"
            >{{ $t('streaming.set_external_src') }}</v-btn>
            <v-text-field
              id="screener_edge_url"
              :label="$t('screener.save.form.screening_url')"
              @input="$emit('input', $event)"
              name="screener_edge_url"
              color="primary"
              prepend-inner-icon="$vuetify.icons.rms_media_link"
              type="url"
              v-if="isExternalSrc"
              :value="value"
              :rules="isExternalSrcRequired ?[rules.required] :[]"
            ></v-text-field>
          </v-flex>
          <!-- <v-flex xs12 md1 class="text-md-right">
            <v-btn
              color="primary"
              dark
              class="mx-0"
              v-if="value"
              @click.stop="watchPreview"
            >{{ $t('screener.btn.preview') }}</v-btn>
          </v-flex> -->
        </v-layout>
      </v-card-text>
    </template>
    <!-- Streaming from MovieEverywhere Encoding -->
    <template v-if="movie && !isExternalSrc">
      <v-card-title
        v-if="
          movie.encoding_status == DEFINES.ENCODING_STATUS.DOWNLOADED ||
            movie.encoding_status == DEFINES.ENCODING_STATUS.ERROR
        "
        class="pb-0"
      >
        <v-spacer></v-spacer>

        <!-- Allow to request for encryption when encoding is downloaded -->
        <v-btn
          outline
          class="ma-0"
          color="primary"
          dark
          @click="confirmReqEncr()"
        >{{ $t('rms.button.encode') }}</v-btn>
      </v-card-title>

      <v-card-title v-if="movie.encoding_status == DEFINES.ENCODING_STATUS.ENCODED" class="pb-0">
        <v-spacer></v-spacer>
        <v-btn
          outline
          class="my-0 mr-0"
          color="error"
          dark
          @click="confirmReqEncr()"
        >{{ $t('screener.btn.delete_and_encode') }}</v-btn>
      </v-card-title>

      <!-- File details -->
      <div
        class="grey--text text--darken-1 font-weight-bold ml-3 pb-2 pt-3"
      >{{ $t('screener.media.details') }}</div>
      <v-divider></v-divider>
      <v-card-text>
        <!-- File name -->
        <div class="pb-2">
          <span class="grey--text text--darken-1">
            {{
            $t('screener.media.name')
            }}
          </span>
          <span class="pl-1 pr-2">:</span>
          <span>{{ movie.file_name }}</span>
        </div>
        <!-- Size -->
        <div class="pb-2">
          <span class="grey--text text--darken-1">
            {{
            $t('screener.media.size')
            }}
          </span>
          <span class="pl-1 pr-2">:</span>
          <span>{{ movie.size }}</span>
        </div>
        <!-- Mime type -->
        <div class="pb-2">
          <span class="grey--text text--darken-1">
            {{
            $t('screener.media.mime')
            }}
          </span>
          <span class="pl-1 pr-2">:</span>
          <span>{{ movie.file_mimetype }}</span>
        </div>
      </v-card-text>

      <!-- Status & URL -->
      <div
        class="grey--text text--darken-1 font-weight-bold ml-3 pb-2"
      >{{ $t('screener.streaming_info') }}</div>
      <v-divider></v-divider>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12 sm12 md6 class="pb-2">
            <span class="grey--text text--darken-1">
              {{
              $t('screener.encoding_status')
              }}
            </span>
            <span class="pl-1 pr-2">:</span>
            <v-chip :color="getStatusColor" class="font-weight-bold" outline small>
              {{
              movie.encoding_status || DEFINES.ENCODING_STATUS.NONE
              }}
            </v-chip>
            <!-- <span class="secondary--text font-weight-medium"></span> -->
          </v-flex>
          <v-flex
            xs12
            sm12
            md6
            class="text-xs-left text-md-right"
            v-if="
            movie.screener_edge_url &&
              movie.encoding_status == DEFINES.ENCODING_STATUS.ENCODED
          "
          >
            <!-- <v-btn
              color="primary"
              dark
              text
              flat
              outline
              class="ma-0"
              @click.stop="watchPreview"
            >{{ $t('screener.btn.preview') }}</v-btn> -->
          </v-flex>
        </v-layout>
      </v-card-text>

      <!-- Logs -->
      <div
        class="grey--text text--darken-1 font-weight-bold ml-3 pb-2"
      >{{ $t('screener.save.encoding_log.title') }}</div>
      <v-divider></v-divider>
      <v-card-text>
        <div v-if="movie.encoding_logs">
          <span v-html="movie.encoding_logs"></span>
        </div>
        <div v-else class="greyDarken1--text">
          <span>{{ $t('screener.save.encoding_no_log.title') }}</span>
        </div>
      </v-card-text>
    </template>

    <!-- Preview Player -->
    <v-container class="pa-0" v-if="showPreview">
      <v-dialog max-width="55vmin" v-model="showPreview" persistent>
        <v-card>
          <v-card-title>
            <div class="title">Screener Preview</div>
            <v-spacer></v-spacer>
            <v-btn small dark icon color="grey" @click="closePreview" class="mx-0">
              <v-icon small>$vuetify.icons.rms_close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <ScreenerPlayer :movie="previewUrl" :subtitles="subtitles"></ScreenerPlayer>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
    <ConfirmationDialog
      v-if="dialog"
      :dialog="dialog"
      @confirm="request_encryption"
      @cancel="dialog = false"
    ></ConfirmationDialog>
  </v-card>
</template>
<script>
import ConfirmationDialog from "@/components/dialogBox/Confirmation";
import ScreenerPlayer from "@/components/screener/Player";
import rules from "@/validation";

export default {
  name: "StreamingDetails",
  props: {
    value: {
      type: String
    },
    isExternalSrc: {
      default: false
    },
    film_id: {
      type: Number
    },
    isExternalSrcRequired: {
      default: false
    }
  },
  data() {
    return {
      dialog: false,
      showPreview: false,
      previewUrl: null,
      rules
    };
  },
  components: {
    ScreenerPlayer,
    ConfirmationDialog
  },
  computed: {
    movie: function() {
      return this.$store.getters["film/getMediasFromId"](
        this.DEFINES.MEDIA.FILM.SCREENERS
      )[0];
    },
    subtitles: function() {
      return this.$store.getters["files/getSubtitles"]();
    },
    getStatusColor: function() {
      if (this.movie.encoding_status == this.DEFINES.ENCODING_STATUS.ENCODED) {
        return "success--text";
      }
      return "secondary--text";
    }
  },
  methods: {
    watchPreview() {
      this.previewUrl = this.isExternalSrc
        ? this.value
        : this.movie.screener_edge_url;
      this.showPreview = true;
    },
    closePreview() {
      this.showPreview = false;
      this.previewUrl = null;
    },

    setMediaEncUrlAsExtSrc() {
      this.$emit("input", this.movie.encoding_url);
    },

    async request_encryption() {
      try {
        await this.$store.dispatch("files/setEncodingStatusRequested", {
          id: this.movie.file_id
        });
        await this.$store.dispatch("files/get", {
          model_type: "film",
          model_id: this.film_id
        });
        this.dialog = false;
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
      }
    },
    confirmReqEncr() {
      this.dialog = true;
    }
  }
};
</script>
